RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, sprintf) {

    'use strict';

    widgets.MetricView = RivalIQ.views.LayoutView.mixin({
        className: 'metric-summary',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        behaviors: function () {
            const me = this;

            const metric = me.getMetric();
            const information = metric.getInformation({
                dimensions: me.getProp('nameDimensions')
            });

            return {
                Titles: RivalIQ.behaviors.Titles,
                Information: {
                    behaviorClass: RivalIQ.behaviors.Information,
                    information: information
                }
            };
        },

        onRenderLoaded: function () {
            const me = this;

            me.$('[data-toggle="popover"]').popover();

            const metric = me.getMetric();
            if (me.getProp('showSparkline') || (metric && metric.get && metric.get('showSparkline'))) {
                let dailyValues = me.sparklineMetric.getValue({
                    format: false
                });

                dailyValues = _.map(dailyValues, _.last);
                RivalIQ.graph.renderSparkline(dailyValues, me.$('.x-sparkline-region')[0]);
            }

            if (!me.getProp('showBenchmarkLine') && me.getProp('submetricDisplayType') === 'upDownCarets' && me.submetric) {
                const value = _.get(me.model.getValue({
                    format: false
                }), [0, 0]);
                if ((_.isNull(value) && me.submetric.get('companyId')) ||
                    (_.isUndefined(value) && _.get(RivalIQ.enums.sourceDetails, [me.submetric.get('source'), 'privateData']))) {
                    let popover;
                    const company = RivalIQ.state.landscape.getCompanyById(me.submetric.get('companyId'));
                    const source = me.submetric.get('source');
                    const hasChannel = RivalIQ.utils.companyDisplay.hasChannel(me.model.get('channel'), company.attributes);
                    const noHistoricData = me.submetric.getNoHistoricData();
                    let earliestDataDateByCompanyId;
                    if (_.get(me.model, 'data.companyData') || me.model.metadata || me.model.companyData || me.model.compareData) {
                        earliestDataDateByCompanyId = me.model.getEarliestDataDate();
                    } else {
                        // NOTE in private curations, we stuff the earliestDataDate data in the privateMetadata that get attached
                        // to the curation in pulic/apps/insights/curations/filters.js
                        const companyData = me.dashboardModel.getCuration().presences.findWhere({
                            companyId: me.model.get('companyId')
                        });
                        earliestDataDateByCompanyId = me.model.getEarliestDataDate(companyData);
                    }
                    const metricObjectType = me.model.getObjectType();
                    let incompleteDataText;

                    // NOTE linkedin is not included in companyDisplay data
                    if (hasChannel || source === RivalIQ.enums.sources.LINKEDIN) {
                        const dataStatus = RivalIQ.apps.Shell.utils.getDataFreshnessState();
                        let subMetrics = [];

                        if (source === RivalIQ.enums.sources.CROSS_CHANNEL) {
                            subMetrics = RivalIQ.data.channels.withChannelCuration()
                                .withAccess()
                                .notHidden(true)
                                .filter(function (channel) {
                                    return _.includes(RivalIQ.enums.sourceDetails[10].subSources, channel.get('source'));
                                })
                                .map(function (channel) {
                                    return {
                                        metric: channel.get('channel')
                                    };
                                });
                        }

                        const incompleteDataType = RivalIQ.utils.incompleteData.getIncompleteDataType(company, source, dataStatus.updateInFlight, me.submetric.get('timePeriod'), earliestDataDateByCompanyId, noHistoricData, subMetrics, metric.get('timeAnalysisMode'));
                        // linkedin is special and needs to open the company configuration modal to map a company to a presence
                        if (incompleteDataType === RivalIQ.enums.incompleteDataType.NO_PRIVATE_ACCESS && source === RivalIQ.enums.sources.LINKEDIN) {
                            const modalData = {
                                noNavigate: true
                            };
                            if (me.dashboardModel.getWidgetInstanceState && me.dashboardModel.getProp('focusWidgetInstanceId')) {
                                const instanceData = me.dashboardModel.getWidgetInstanceState(me.dashboardModel.getProp('focusWidgetInstanceId'));
                                modalData.linkedInPresences = instanceData?.linkedInPresences;
                                modalData.unassociatedPresences = instanceData?.unassociatedPresences;
                                modalData.accountCompanies = instanceData?.accountCompanies;
                            } else {
                                const curation = me.dashboardModel.getCuration();
                                modalData.accountCompanies = curation.accountCompanies;
                                modalData.accountPresences = curation.accountPresences;
                            }

                            const popoverView = Marionette.ItemView.extend({
                                template: '#configureLinkedInPresencesPopoverTemplate',
                                ui: {
                                    editBtn: '.x-edit-connections'
                                },
                                events: {
                                    'click @ui.editBtn': 'onEditClicked'
                                },
                                onEditClicked: function () {
                                    const InsightsApp = RivalIQ.apps.Insights;
                                    RivalIQ.execute('show:modal', new InsightsApp.views.LinkedInPresenceConfigurationModal(modalData));
                                },
                                serializeData: function () {
                                    return {
                                        companyName: company.get('name'),
                                        channelName: RivalIQ.enums.sourceDetails[source].name
                                    };
                                }
                            });
                            const popoverModal = new popoverView({});
                            popover = {
                                content: popoverModal.render().el
                            };
                        } else {
                            incompleteDataText = RivalIQ.utils.incompleteData.getIncompleteDataText(incompleteDataType, company.attributes, me.submetric.get('timePeriod'), company.get('name'), me.submetric.getName(), source, earliestDataDateByCompanyId, metricObjectType, noHistoricData, subMetrics);
                            const templateFn = incompleteDataText.unboldTitle ? RivalIQ.utils.incompleteData.incompleteDataPopoverTemplateNoBold : RivalIQ.utils.incompleteData.incompleteDataPopoverTemplate;
                            popover = {
                                content: templateFn({
                                    title: incompleteDataText.title,
                                    description: incompleteDataText.description
                                })
                            };
                        }
                    } else {
                        incompleteDataText = RivalIQ.utils.incompleteData.getIncompleteDataText(RivalIQ.enums.incompleteDataType.NO_ACTIVE_RECORDS, company.attributes, me.submetric.get('timePeriod'), company.get('name'), me.submetric.getName(), source, earliestDataDateByCompanyId, metricObjectType, noHistoricData, [{
                            metric: RivalIQ.enums.sourceDetails[source].channel
                        }]);
                        popover = {
                            content: incompleteDataText.title
                        };
                    }

                    if (popover) {
                        RivalIQ.utils.tooltip.addPopover(me.$el.find('.x-not-enough-history'), popover);
                    }
                }
            }

            const warnings = me._getWarnings();
            if (_.get(warnings, ['mainMetric', 'popover'])) {
                RivalIQ.utils.tooltip.addPopover(me.$el.find('.main-metric-warning'), warnings.mainMetric.popover);
            }
            if (_.get(warnings, ['submetric', 'popover'])) {
                RivalIQ.utils.tooltip.addPopover(me.$el.find('.submetric-warning'), warnings.submetric.popover);
            }
        },

        getTemplate: function () {

            const me = this;
            if (me.getProp('submetricDisplayType') === 'mostEngagingCrossChannel') {
                return '#widgetMetricMostEngagingChannelTemplate';
            }
            return '#widgetMetricTemplate';
        },

        getMetric: function () {
            const me = this;

            return me.dashboardModel.metric;
        },

        getSubmetric: function () {
            const me = this;

            return me.dashboardModel.submetric;
        },

        getDeltaMetric: function () {
            const me = this;

            return me.dashboardModel.deltaMetric;
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();

            let metricDefinition = me.getMetric();

            // This widget supports old and new style metrics, the former of which does not have a .build method. Sigh.
            // Those widgets take on the responsibility of making sure that the metrics properly extend props.
            if (metricDefinition.build && !me.getProp('doNotRebuildMetrics')) {
                metricDefinition = metricDefinition.build(props);
            }
            let submetric = me.getSubmetric();
            const deltaMetric = me.getDeltaMetric();
            const showSparkline = me.getProp('showSparkline') || metricDefinition.get('showSparkline');
            const dimension = me.getProp('dimension');

            const metrics = [metricDefinition];
            let submetricIdx;
            let deltaMetricIdx;
            let sparklineMetricIdx;

            if (submetric) {
                submetricIdx = metrics.length;

                if (submetric.build && !me.getProp('doNotRebuildMetrics')) {
                    submetric = submetric.build(props);
                }
                metrics.push(submetric);
            }
            if (deltaMetric) {
                deltaMetricIdx = metrics.length;
                metrics.push(deltaMetric);
            }
            if (dimension) {
                metrics.push(metricDefinition.build({
                    dimensions: dimension
                }));
            }

            if (showSparkline) {
                sparklineMetricIdx = metrics.length;
                let interval;
                if (props.interval) {
                    interval = props.interval;
                } else {
                    const timePeriod = me.getProp('timePeriod');
                    interval = RivalIQ.metric.timePeriod.getDefaultInterval(timePeriod);
                }

                metrics.push(metricDefinition.build({
                    dimensions: [interval]
                }));
            }

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch()
                .done(function (collection) {
                    me.model = collection.at(0);
                    if (submetric) {
                        me.submetric = collection.at(submetricIdx);
                    }
                    if (deltaMetric) {
                        me.deltaMetric = collection.at(deltaMetricIdx);
                    }
                    if (showSparkline) {
                        me.sparklineMetric = collection.at(sparklineMetricIdx);
                    }
                });
        },

        serializeData: function () {
            const me = this;

            const taEnums = RivalIQ.enums.timeAnalysisMode;
            const mainAnalysisPeriods = [taEnums.MAIN_PERIOD, taEnums.DAILY_VALUES];
            const changeAnalysisPeriods = [taEnums.DELTA_RELATIVE, taEnums.DELTA_ABSOLUTE];
            const props = me.getProps();
            const metricOptions = props.metricOptions || {};
            if (me.dashboardModel.getCuration().isCustomDashboard && me.model.get('timeAnalysisMode') === taEnums.DELTA_RELATIVE) {
                metricOptions.precision = 2;
            }

            const unabbreviatedOptions = _.defaults({
                format: false
            }, metricOptions);

            let unabbreviatedValue = me.model.getValue(unabbreviatedOptions);

            // Cross-Channel most engaging channel logic
            let mostEngagingChannel;
            if (props.submetricDisplayType === 'mostEngagingCrossChannel' && unabbreviatedValue) {
                mostEngagingChannel = unabbreviatedValue[0];

                unabbreviatedValue.map(function (channelArray) {
                    if (channelArray[1] > mostEngagingChannel[1]) {
                        mostEngagingChannel = channelArray;
                    }
                });
            }

            // NOTE if we are dealing with an array value we need to flatten it
            // by one level so that the formatter below will correctly detect
            // the missing data case for new style metrics (like those in
            // Custom Dashboards, see #22798)
            if (_.isArray(unabbreviatedValue)) {
                unabbreviatedValue = _.flatten(unabbreviatedValue);
            }

            let metricName = me.model.get('abbreviatedName');
            if (!metricName) {
                if (me.dashboardModel.getCuration().isCustomDashboard) {

                    const nameDimensions = _.without(me.getProp('nameDimensions'), 'channel');
                    metricName = RivalIQ.metric.names.metricName(me.model.attributes, {
                        dimensions: nameDimensions,
                        abbreviateName: true,
                        includeAggregate: true
                    });
                } else {
                    metricName = me.model.getName({
                        dimensions: props.nameDimensions
                    });
                }
            }

            let value = me.model.getValue(metricOptions);
            let labelClass = '';
            if (_.includes(changeAnalysisPeriods, me.model.get('timeAnalysisMode'))) {
                labelClass = RivalIQ.formatter.relativeMetricClass(_.last(unabbreviatedValue));
            }

            if (me.model.get('timeAnalysisMode') === taEnums.DELTA_ABSOLUTE) {
                value = RivalIQ.formatter.formatAbbreviatedWithSign(_.last(unabbreviatedValue), false, metricOptions);
            }

            const data = {
                metric: {
                    name: metricName,
                    value: value,
                    unabbreviatedValue: me.model.format(unabbreviatedValue, {
                        expand: true
                    }),
                    unformattedValue: (_.isArray(unabbreviatedValue) ? _.head(unabbreviatedValue) : unabbreviatedValue),
                    labelClass: labelClass
                },

                submetric: null,
                deltaMetric: null,
                submetricDisplayType: props.submetricDisplayType
            };

            if (me.dashboardModel.getCuration().isCustomDashboard) {
                data.metric.sourceIcon = RivalIQ.enums.sourceDetails[me.model.getSource()].iconSvg;
            }

            if (props.submetricDisplayType === 'mostEngagingCrossChannel') {
                if (mostEngagingChannel && mostEngagingChannel[1] > 0) {
                    data.metric.fontIcon = RivalIQ.data.channels.get(mostEngagingChannel[0]).get('fontIcon');
                    data.metric.name = mostEngagingChannel[0];
                    data.metric.value = data.metric.unabbreviatedValue = mostEngagingChannel[1];
                } else {
                    data.metric.noEngagement = true;
                }
            }

            if (me.submetric) {
                const submetricOptions = props.submetricOptions;
                const unformattedValue = me.submetric.getValue(_.extend({
                    format: false
                }, submetricOptions));

                // null submetric value if (see #27191):
                // 1. private metric using a Compare Against option (company avg, landscape avg)
                // 2. main metric's display value is not main period AND Compare Against is set to Previous Period.
                // note: daily values here displays main period with a sparkline
                const isPrivateData = _.get(RivalIQ.enums.sourceDetails, [me.submetric.get('source'), 'privateData']);
                const hasMultiPrivateChannelAdvanced = RivalIQ.state.plan.get('has_multi_handle_private_advanced');
                const useBenchmarkValue = props.selectedBenchmarkCompareAgainst;
                const isMainPeriod = _.includes(mainAnalysisPeriods, me.model.get('timeAnalysisMode'));
                let displayNull = false;

                if (me.dashboardModel.getCuration().isCustomDashboard) {
                    if (isMainPeriod) {
                        if (useBenchmarkValue && (isPrivateData && !hasMultiPrivateChannelAdvanced)) {
                            displayNull = true;
                        }
                    } else {
                        if (!useBenchmarkValue) {
                            displayNull = true;
                        } else if (isPrivateData && !hasMultiPrivateChannelAdvanced) {
                            displayNull = true;
                        }
                    }
                }

                let popoverDescription = '';
                if (displayNull) {
                    me.submetric.data = null;
                    if (isPrivateData && useBenchmarkValue) {
                        popoverDescription = RivalIQ.strings.favorites_builder_show_benchmark_line_private_metric_description;
                    } else {
                        popoverDescription = RivalIQ.strings.favorites_builder_non_compare_submetric_description;
                    }
                }

                let submetricValue = me.submetric.getValue(submetricOptions);
                if (me.submetric.get('timeAnalysisMode') === taEnums.DELTA_ABSOLUTE) {
                    submetricValue = RivalIQ.formatter.formatAbbreviatedWithSign(_.last(unformattedValue), false, submetricOptions);
                }

                data.submetric = {
                    name: me.submetric.getName(),
                    value: submetricValue,
                    displayValue: !displayNull,
                    unformattedValue: _.get(unformattedValue, [0, 0], unformattedValue),
                    popoverDescription: popoverDescription
                };

                let displayString = me.submetric.get('displayString');

                if (!displayString && props.submetricType === 'delta_relative') {
                    displayString = RivalIQ.strings.delta_relative_submetric;
                }

                if (displayString) {
                    if (_.isFunction(displayString)) {
                        data.submetric.displayString = displayString(data.submetric.value);
                    } else {
                        data.submetric.displayString = sprintf(displayString, data.submetric.value);
                    }
                }
            }

            if (me.deltaMetric) {
                data.deltaMetric = {
                    value: me.deltaMetric.getValue(props.deltaMetricOptions),
                    unformattedValue: me.deltaMetric.getValue(_.extend({
                        format: false
                    }, props.deltaMetricOptions))
                };
            }

            data.warnings = me._getWarnings();
            return data;
        },

        _getWarnings: function () {
            const me = this;

            const warnings = {};

            // main metric warning
            const metricCalculationMetadata = me.model && me.model.getCalculationMetadata && me.model.getCalculationMetadata(me.model.get('companyId'));

            let missingAllSources = _.get(metricCalculationMetadata, ['missingAllSources']);
            const isMissingSources = !_.isEmpty(_.get(metricCalculationMetadata, ['missingSources']));
            const timeAnalysisMode = me.model.get('timeAnalysisMode');

            if (isMissingSources && _.includes([RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE, RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE], timeAnalysisMode)) {
                missingAllSources = true;
            }

            if (missingAllSources || isMissingSources) {
                // Glance widget has different rules than other widgets; we'll show the warning here if there is partial or full
                // missing data in this metric.
                warnings.mainMetric = RivalIQ.utils.incompleteData.getIncompleteDataPopover('companyId', me.model.get('companyId'), me.model, metricCalculationMetadata);
            }

            const isSubmetricDifferentCompany = (me.submetric && me.model.get('benchmarkCompaniesFilter') !== me.submetric.get('benchmarkCompaniesFilter'));
            if (missingAllSources && !isSubmetricDifferentCompany) {
                warnings.submetric = warnings.mainMetric;
                delete warnings.mainMetric;
                warnings.elideSubmetric = true;
                return warnings;
            }

            // submetric warning
            const submetricCalculationMetadata = me.submetric && me.submetric.getCalculationMetadata && me.submetric.getCalculationMetadata(me.submetric.get('companyId'));
            if (submetricCalculationMetadata) {

                if (me.submetric.get('benchmarkCompaniesFilter')) {
                    // The glance widget has slighly different rules for showing warning triangles than the other widgets; if the submetric is
                    // a benchmark widget, then show a triangle if the data is partially or totally missing.

                    const benchmarkCompareAgainst = RivalIQ.apps.Overview.utils.getSelectedBenchmarkCompareAgainst(me.submetric.get('selectedBenchmarkCompareAgainst'));
                    const incompleteDataDetails = RivalIQ.utils.incompleteData.getBenchmarkIncompleteDataDetails(submetricCalculationMetadata, me.submetric, benchmarkCompareAgainst);

                    if (incompleteDataDetails) {
                        if (incompleteDataDetails.dataNotAvailable) {
                            warnings.submetric = {
                                popover: incompleteDataDetails.dataNotAvailableTooltip
                            };
                            warnings.elideSubmetric = true;
                        } else if (incompleteDataDetails.partialDataTooltip) {
                            warnings.submetric = {
                                popover: incompleteDataDetails.partialDataTooltip
                            };
                        }
                    }
                } else {
                    // If warning area will be used to say why we're not showing the submetric value. This is the last resort; if the main metric was
                    // partially missing, then that warning would take precidence.
                    const details = RivalIQ.utils.incompleteData.getIncompleteDataPopover('companyId', me.submetric.get('companyId'), me.submetric, submetricCalculationMetadata);
                    warnings.submetric = details;
                }
            }

            return warnings;
        }
    });

    widgets.MetricWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: widgets.MetricView,
        processProps: function (props) {
            const me = this;

            if (props.metrics) {
                const metrics = _.map(props.metrics, function (metric) {
                    const built = RivalIQ.metric.build(props, metric);
                    return RivalIQ.metric.pin(built);
                });

                const metric = _.head(metrics);
                me.metric = new RivalIQ.models.MetricDefinition(metric);
                if (props.submetricType === 'delta_relative') {
                    const submetric = RivalIQ.metric.build(metric, {
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                    });

                    me.submetric = new RivalIQ.models.MetricDefinition(submetric);
                } else if (metrics.length > 1) {
                    me.submetric = new RivalIQ.models.MetricDefinition(metrics[1]);
                }
            } else {
                props = widgets.Chart.buildMetrics(me, props);
            }

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC, widgets.MetricWidget);

}, window.s, window.sprintf);
